import addressLabel from "./addressLabel.js";
import addressTable from "./addressTable.js";
import addressTableSecond from "./addressTableSecond.js";
import addressTableThird from "./addressTableThird.js";
import assetTable from "./assetTable.js";
import addressTabs from "./addressTabs.js";
import balanceAddress from "./balanceAddress.js";
import btcdetail from "./btcdetail.js";
import btctabs from "./btctabs.js";
import generalAddress from "./generalAddress.js";
import inputbtctable from "./inputbtctable.js";
import otherInfo from "./otherInfo.js";
import outputbtctabel from "./outputbtctabel.js";
import tradinganalytics from "./tradinganalytics.js";
import transactionchart from "./transactionchart.js";

export default {
  addressLabel,
  addressTable,
  addressTableSecond,
  addressTableThird,
  assetTable,
  addressTabs,
  balanceAddress,
  btcdetail,
  btctabs,
  generalAddress,
  inputbtctable,
  otherInfo,
  outputbtctabel,
  tradinganalytics,
  transactionchart,
};
